/* RESPONSIBLE TEAM: team-workflows */
import ENV from 'embercom/config/environment';

export default class FaviconCounter {
  hasLoaded = false;
  base_favicon_image = null;
  favicon_data_64 =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADP0lEQVR4Ae2bA8wkSxSFn23btt+Lk2drbSNa27Zt27Zt27btb+esO907yKj+7TrJTQZ37j31zUyz6jaXCvJNINoEYmMgzgSCFB5nroylzaWx3VQFeSQQ3fWhWzy6a6xeg5+tBJ/EbAeEK1TwWXS/8T+PT+MbAWjjYwBtBWCjjwFsFIAzPgZwVgBIRtxdBNJ2UuhxEiHEuuA71eDvtvBoyeB5g5ciSXocNFe1VFO1jQbwbzs4dx6krQfhyTLeeY+VwiW95pX7VBnVQlJt9TAXwLDlOJS9u3feq5VxSa955KqGQ+phLICJa3Go4ICoAaiGQ+qRFAAPFE85AO4vFkMAdxWGQUvgwgXYuB/er2EugA9qyqO8yrO8Rw+A/9vjUI/5xgKQN4fkPWoAbgMGAIiyvwVgAVgAFoAFYAFYABaABWABWAAWgAVgAVgAFoAFECQsgCzdcGjQEmMByJtD8h41gEdKwqrdSJw6Cz80NxaAvMmjJM/yHj0Axb1F4buG8ExZ8+8LyKO8yrO9M2QBJBjAkGXBN0LR3xxVD4MB/NEazp5H0i0qnijtnfdceVzSa165qqFaoNrqYTAAxetV4KcW8FCJ4HkrdyFJehw0V7VUU7UNmSARfbxSCZpMVuix+VNkZJL7iumxySGPEQINp+CU9UjsOwapO5g7+FQd5BFJnuU9agCaxeVSz/nwQgVzBq4NaNe5uCTvUQP4sw2eOnYaao6Fp8smb+CahFV1NBw5hZfkPXoAtxdyTTxw6MQZaDUdvm2QuIF/XheaToGjp8Bb8izvMdwI5uwBh04SVMt3QoUR8Gkdd/No4+NaUHooLN5OUMmjvMZlN6gTjU6z4fwFQmr/cdDpafkR8Fcb0Pyde8KYEaqcd6uDfr5lhsGAxbDnKCEkT/Imj/E/DtBEKW0I1TRiHT4Ja/fCwm2O0Gt6L0LJg7zIUxIOhHRkVmUUbDlIwrX1oHrLgwFHgncUgp9bQuvpsO0QcZJqq4d6qafBh8L6D+fuCS2nwezNaMMUofQZfVY1VEs1DZgtHu0+W3sHndRk7ALZukP+PqDQY72mb1Y5miCdKF92wYRdMuPvRVNt7LI5u3DSLp21i6d9vXz+IvTkUEt9pGYyAAAAAElFTkSuQmCC';
  favicon_data_16 =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAAXNSR0IArs4c6QAAAiVJREFUOBGFk9+LTVEUxz/n3Ds/bn4VtxhGFOJxhDcPiJKaKE1p/AeSO35NGg9448HklsdBefAPTPEiT0qhyHhSisKkPOAWw713ju9377MbTcmqfc4+a33XWt/9XftkjBQV1tLJ/bg2DBmNokBWrS+B0R2lxx/n98FsC3KHHzfg+xysWWrEmHJCliIFTaaeFEX/uaKY+aTAiaLIu2U0gfKL0zB5GL7+cK9Uowu9PdBuw56t0FKD5+8FUMvcDW4dh+X90NcHB7fB7VE4LVooITDPMqhodTsiv0sUf8H0y9TiVHHDsEBVGcEERi2puEICxNDC06CPVPOQPQ8718PeLcrQvleZiDjrLKPKjonQHREzQRM14Sl9u23QztWSENoGM3FbAHRVdrF1Sl8ckI43PKTSKn/vmchLQUvs0QWhrh6BcfHYuBJujsDrC7CqFmtmnBHOjK1BImINzCGjGXWoSiiDknmfjmpf2vudzPt5mlEnVd9ch4FlMLgCXk1IDvGcPBqX9zPyOWaMsSWjRlDB3ScOwDFdwjkd2GaZ2vJ7eW/2jhljbGIcCzhDVkobP/7xXIwROZmelx7Az99Q6y1HLXfPX2f2+GsS7+7TiHGOLc5JGpzUGPbrMl+5Dy/ehZhFilbyHNoAlw/Bwzca1yOFVHDhr/Ihdca6hNq9CbYPwmoJZvvcUtEP+h3fwpdvcri7z6KVhZ97gOu6EvHOy/9fc7JGyCxn/wCk7K5z+D1LVAAAAABJRU5ErkJggg==';
  favicon_dev_data_64 =
    'data:image/png;base64,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';
  favicon_dev_data_16 =
    'data:image/png;base64,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';
  favicon_size = window.devicePixelRatio > 1 ? 64 : 16;
  size_factor = window.devicePixelRatio > 1 ? 4 : 1;
  pixelNumbers = {
    0: [
      [1, 1, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1, 1],
    ],
    1: [
      [0, 1, 0],
      [1, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [1, 1, 1],
    ],
    2: [
      [1, 1, 1],
      [0, 0, 1],
      [1, 1, 1],
      [1, 0, 0],
      [1, 1, 1],
    ],
    3: [
      [1, 1, 1],
      [0, 0, 1],
      [0, 1, 1],
      [0, 0, 1],
      [1, 1, 1],
    ],
    4: [
      [0, 0, 1],
      [0, 1, 1],
      [1, 0, 1],
      [1, 1, 1],
      [0, 0, 1],
    ],
    5: [
      [1, 1, 1],
      [1, 0, 0],
      [1, 1, 1],
      [0, 0, 1],
      [1, 1, 1],
    ],
    6: [
      [0, 1, 1],
      [1, 0, 0],
      [1, 1, 1],
      [1, 0, 1],
      [1, 1, 1],
    ],
    7: [
      [1, 1, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 1, 0],
      [0, 1, 0],
    ],
    8: [
      [1, 1, 1],
      [1, 0, 1],
      [1, 1, 1],
      [1, 0, 1],
      [1, 1, 1],
    ],
    9: [
      [1, 1, 1],
      [1, 0, 1],
      [1, 1, 1],
      [0, 0, 1],
      [1, 1, 0],
    ],
    '+': [
      [0, 0, 0],
      [0, 1, 0],
      [1, 1, 1],
      [0, 1, 0],
      [0, 0, 0],
    ],
    k: [
      [1, 0, 1],
      [1, 1, 0],
      [1, 1, 0],
      [1, 0, 1],
      [1, 0, 1],
    ],
  };

  async updateFaviconCounter(newValue) {
    await this._refreshFavicon(newValue);
  }

  async resetFaviconCounter() {
    await this.updateFaviconCounter(0);
  }

  _generateFavicon(counter) {
    if (counter === undefined || counter === null || counter < 0) {
      counter = '0';
    } else if (typeof counter !== 'string') {
      counter = counter.toString();
    }

    if (!this.textedCanvas) {
      this.textedCanvas = [];
    }

    if (!this.textedCanvas[counter]) {
      let textedCanvas = document.createElement('canvas');
      textedCanvas.height = textedCanvas.width = this.favicon_size;
      let context = textedCanvas.getContext('2d');
      context.drawImage(this.base_favicon_image, 0, 0, this.favicon_size, this.favicon_size);

      if (counter === '0') {
        return textedCanvas.toDataURL('image/png');
      }

      context.fillStyle = '#fef4ac';
      context.strokeStyle = '#dabc5c';
      context.strokeWidth = 1;

      let count = counter.length;
      if (count >= 4) {
        counter = '1k+';
        count = counter.length;
      }

      let counterHeight = this.pixelNumbers[0].length;
      let counterWidth = 0;
      let padding = count < 4 ? 1 : 0;
      let topMargin = 0;
      let index;

      for (index = 0; index < count; ++index) {
        counterWidth += this.pixelNumbers[counter[index]][0].length;
        if (index < count - 1) {
          counterWidth += padding;
        }
      }
      counterWidth *= this.size_factor;
      counterHeight *= this.size_factor;
      counterWidth =
        counterWidth > textedCanvas.width - 4 * this.size_factor
          ? textedCanvas.width - 4 * this.size_factor
          : counterWidth;
      context.fillRect(
        textedCanvas.width - counterWidth - 4 * this.size_factor,
        topMargin,
        counterWidth + 4 * this.size_factor,
        counterHeight + 4 * this.size_factor,
      );

      let digit;
      let digitsWidth = counterWidth;
      for (index = 0; index < count; ++index) {
        digit = counter[index];

        if (this.pixelNumbers[digit]) {
          let map = this.pixelNumbers[digit];
          let height = map.length;
          let width = map[0].length;

          context.fillStyle = '#2c3323';

          for (let y = 0; y < height; ++y) {
            for (let x = 0; x < width; ++x) {
              if (map[y][x]) {
                context.fillRect(
                  14 * this.size_factor - digitsWidth + x * this.size_factor,
                  topMargin + (y + 2) * this.size_factor,
                  this.size_factor,
                  this.size_factor,
                );
              }
            }
          }
          digitsWidth -= (width + padding) * this.size_factor;
        }
      }

      context.strokeRect(
        textedCanvas.width - counterWidth - 3.5 * this.size_factor,
        topMargin + 0.5 * this.size_factor,
        counterWidth + 3 * this.size_factor,
        counterHeight + 3 * this.size_factor,
      );
      this.textedCanvas[counter] = textedCanvas;
    }

    return this.textedCanvas[counter].toDataURL('image/png');
  }

  async _refreshFavicon(newValue) {
    if (!this.hasLoaded) {
      let image_data = this._getImageData();
      this.base_favicon_image = await loadImage(image_data);
      this.hasLoaded = true;
    }

    this._updateFavicon(newValue);
  }

  _getImageData() {
    let imageData = null;
    if (ENV.environment === 'development') {
      imageData = this.favicon_size === 16 ? this.favicon_dev_data_16 : this.favicon_dev_data_64;
    } else {
      imageData = this.favicon_size === 16 ? this.favicon_data_16 : this.favicon_data_64;
    }
    return imageData;
  }

  _updateFavicon(newValue) {
    let faviconHref = this._generateFavicon(newValue);
    let linkElements = document.querySelectorAll('link[rel="shortcut icon"], link[rel="icon"]');
    Array.prototype.slice
      .call(linkElements)
      .forEach((linkElement) => linkElement.setAttribute('href', faviconHref));
  }
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    let image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', reject);
    image.src = src;
  });
}
